var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "record-picker" },
    [
      _c("TableDetail", {
        attrs: {
          defaultTableId: _vm.tableId,
          moduleMode: true,
          pickerMode: true,
        },
        on: { "record-selected": _vm.onRecordSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }